import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

    settings: SafeHtml = '';

  constructor(private apiService: ApiService,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadSetting()
  }

  loadSetting(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.settings = this.sanitizer.bypassSecurityTrustHtml(
          response.settings.privacy_and_policy || ''
        );
      }, 
      error: (error: any) => {
        console.log(error);
      }
    });
  }

}
